import React from "react";
import styled, {css} from "styled-components";
import {AccordionDetails, Grid} from "@material-ui/core";
import {AsessmentBottomWidget} from "./asessment_bottom";
import {ResultInterface} from "../../../interface/challenge/details";
import {Skeleton} from "@material-ui/lab";
import {formatAddress} from "../../../utils/formatBalance";
import {StatusWidget} from "../../claims/widget/status";

export const AsessmentWidget: React.FC<{ resultList: ResultInterface[] }> = ({resultList}) => {
    return (
        <Grid container>
            <TalWidget />
            {resultList? resultList.map((e,i)=><CellWidget key={"resultList"+i} cellModel={e}/>) :
                new Array(6).map(()=><LoadingWidget />)}
            <AsessmentBottomWidget />

        </Grid>
    );
}


const LoadingWidget: React.FC = () => {
    return (
            <div><Skeleton variant="text" height={20}/></div>
    );
}


const TalWidget: React.FC = () => {
    return (<TabStyle>
        <div>Auditor</div>
        <div>Signatures</div>
        <div>Status</div>
    </TabStyle>);
}

const CellWidget: React.FC<{cellModel:ResultInterface}> = ({cellModel}) => {
    return (
        <CellStyle>
            <div>{formatAddress(cellModel.arbiter_id)}</div>
            <div>{formatAddress(cellModel.sign_hash)}</div>
            <div><StatusWidget status={cellModel.status} /></div>

        </CellStyle>
    );
}

const CellStyle = styled.div`
  width: 100%;
  border-bottom: 1px solid #D8D8D8;
  height: 68px;

  &:last-child {
    border-bottom: none;
  }

  div {
    color: #666666;
    font-size: 16px;
    font-weight: 400;
  }

  div:nth-child(3) {
    color: #30B29A;
  }

  ${() => PaddingCss}
`

const TabStyle = styled.div`
  width: 100%;
  height: 48px;

  div{
    font-size: 14px;
    font-weight: 400;
    color: #222222;
  }

  ${() => PaddingCss}
`

const PaddingCss = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;

  div {
    flex: 2;

    &:last-child {
      flex: 1;
    }
  }
`
